module.exports = __webpack_public_path__ + "static/media/gizmodo.ec3987eb.png";